import { render } from "./globalStat.vue?vue&type=template&id=0f7b2191&scoped=true"
import script from "./globalStat.vue?vue&type=script&lang=js"
export * from "./globalStat.vue?vue&type=script&lang=js"

import "./globalStat.vue?vue&type=style&index=0&id=0f7b2191&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7b2191"]])

export default __exports__